<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout column>
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                <v-card-text>
                  <h3 style="text-align: left;margin-bottom: 10px">Empty Container Report</h3>
                  <v-divider divider: true></v-divider>
                  <v-layout row wrap>
                    <v-flex xs3 child-flex>
                      <v-layout row wrap>
                        <label style="margin-top:20px;margin-right: 10px">Show</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label=""
                          target="#dropdown-example"
                        ></v-overflow-btn>
                        <label style="margin-top:20px;margin-left: 10px">Entries</label>
                      </v-layout>
                    </v-flex>
                    <v-flex xs3 child-flex></v-flex>
                    <v-flex xs6 child-flex>
                      <v-layout row wrap>
                        <v-text-field
                          label="Search"
                        ></v-text-field>
                        <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-data-table
                    :headers="headers"
                    :items="desserts"
                    class="elevation-1"
                    style="width:1200px"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.no}}</td>
                      <td class="text-xs-left">{{ props.item.salesorderno}}</td>
                      <td class="text-xs-left"><a href="">{{ props.item.amebookingno}}</a></td>
                      <td class="text-xs-left">{{ props.item.slbookingno}}</td>
                      <td class="text-xs-left">{{ props.item.shippingline}}</td>
                      <td class="text-xs-left">{{ props.item.containerno}}</td>
                      <td class="text-xs-left" style="color:green" v-if="props.item.containerstatus == 'Approve'">{{ props.item.containerstatus}}   |  <v-btn @click="dialog = true" flat ><v-icon style="margin-left:0px">edit</v-icon></v-btn></td>
                      <td class="text-xs-left" style="color:red" v-if="props.item.containerstatus == 'Reject'">{{ props.item.containerstatus}}   |  <v-btn flat @click="dialog1 = true"><v-icon style="margin-left:0px">edit</v-icon></v-btn></td>
                    </template>
                  </v-data-table>
                                <v-dialog
                                    v-model="dialog"
                                    width="800"
                                  >
                                    <v-card>
                                      <v-card-title
                                        class="headline lighten-2"
                                        primary-title
                                        style="color:#1565C0"
                                      >
                                        Approve Container
                                      </v-card-title>
                                      <v-divider></v-divider>
                                      <v-card-text>
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-layout row wrap>
                                              <v-flex xs2></v-flex>
                                              <v-flex xs6 style="margin-left:80px">
                                                <label style="text-align: left">Specify Reason for Approval</label>
                                                <v-overflow-btn
                                                :items="dropdown_list"
                                                label=""
                                                target="#dropdown-example"
                                                style="margin-top:10px;"
                                                outline
                                                ></v-overflow-btn>
                                                <label style="text-align: left">General Comments</label>
                                                <v-textarea
                                                  outline
                                                  name="input"
                                                  label=""
                                                  value=""
                                                  style=""
                                                ></v-textarea>
                                              </v-flex>
                                              <v-flex xs2></v-flex>
                                            </v-layout>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>

                                      <v-divider></v-divider>

                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          flat
                                          @click="dialog = false"
                                        >
                                          Cancel
                                        </v-btn>
                                        <v-btn
                                          color="primary"
                                          @click="dialog = false"
                                        >
                                          Submit
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                                  <v-dialog
                                    v-model="dialog1"
                                    width="800"
                                  >
                                    <v-card>
                                      <v-card-title
                                        class="headline lighten-2"
                                        primary-title
                                        style="color:#1565C0"
                                      >
                                        Approve Container
                                      </v-card-title>
                                      <v-divider></v-divider>
                                      <v-card-text>
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-layout row wrap>
                                              <v-flex xs2></v-flex>
                                              <v-flex xs6  style="margin-left:80px">
                                                <label style="text-align: left">Specify Reason for Rejection</label>
                                                <v-overflow-btn
                                                :items="dropdown_list"
                                                label=""
                                                target="#dropdown-example"
                                                style="margin-top:10px;"
                                                outline
                                                ></v-overflow-btn>
                                                <label style="text-align: left">General Comments</label>
                                                <v-textarea
                                                  outline
                                                  name="input"
                                                  label=""
                                                  value=""
                                                  style=""
                                                ></v-textarea>
                                                <label style="text-align: left">Selected Rejected Container Images</label>
                                                <v-btn class="primary" style="">Choose Files to upload</v-btn>
                                                <p style="text-align: center">Uploaded Images Preview</p>
                                              </v-flex>
                                              <v-flex xs2></v-flex>
                                            </v-layout>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>

                                      <v-divider></v-divider>

                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          flat
                                          @click="dialog1 = false"
                                        >
                                          Cancel
                                        </v-btn>
                                        <v-btn
                                          color="primary"
                                          @click="dialog1 = false"
                                        >
                                          Submit
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      dropdown_list: [1, 2, 3, 4, 5],
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Sales Order No', value: 'salesorderno' },
        { text: 'AME Booking No', value: 'amebookingno' },
        { text: 'SL Booking No', value: 'slbookingno' },
        { text: 'Shipping Line', value: 'shippingline' },
        { text: 'Container No', value: 'containerno' },
        { text: 'Container Status', value: 'containerstatus' }
      ],
      desserts: [
        {
          no: '1',
          salesorderno: '986325417',
          amebookingno: 'AME / FF / 145287963',
          slbookingno: '9876769856',
          shippingline: 'MAERSK LINE',
          containerno: 'MSKU123654',
          containerstatus: 'Approve'
        },
        {
          no: '2',
          salesorderno: '986325417',
          amebookingno: 'AME / FF / 145287963',
          slbookingno: '9876769856',
          shippingline: 'MAERSK LINE',
          containerno: 'MSKU123654',
          containerstatus: 'Approve'
        },
        {
          no: '3',
          salesorderno: '986325417',
          amebookingno: 'AME / FF / 145287963',
          slbookingno: '9876769856',
          shippingline: 'MAERSK LINE',
          containerno: 'MSKU123654',
          containerstatus: 'Reject'
        }
      ],
      show1: true,
      show2: false,
      show3: false,
      dialog: false,
      dialog1: false
    }
  },
  mounted () {
    console.log('wynumtrack page')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// src/components/Emptycontainerreport.vue